import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { config } from '../../config';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const liffIdPrivilege = config.liff_id.privilege;
const liffIdPrivilegePortal = config.liff_id.privilege_portal;

const PrivilegeCheck = loadable(() => import('./PrivilegeCheck'), { fallback: null });

const PrivilegePortal = loadable(() => import('./PrivilegePortal'), { fallback: null });

// const NotFound = Loadable({
//     loader: () => import('../NotFound'),
//     loading: () =>null,
// });

export default function PrivilegeRoute() {
	return (
		<Routes>
			<Route path="/" element={
				<AuthProvider liffId={liffIdPrivilege}>
					<CheckCMSNewVersionLayer>
						<PrivilegeCheck />
					</CheckCMSNewVersionLayer>
				</AuthProvider>
			} />
			<Route path="/portal" element={
				<AuthProvider liffId={liffIdPrivilegePortal}>
					<CheckCMSNewVersionLayer>
						<PrivilegePortal />
					</CheckCMSNewVersionLayer>
				</AuthProvider>
			} />
			{/* <Route path="*" element={<NotFound />} /> */}
		</Routes>
	);
}
